import { Injectable } from '@angular/core';
import { BaseApiService } from '@uw/core/services/baseapi.service';
import { BehaviorSubject, Observable, map, tap } from 'rxjs';
import { DonorProfile } from '../../modules/profile/models/donor-profile.model';
import { CampaignService } from './campaign.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService extends BaseApiService {
  _userOptoutState = new BehaviorSubject<boolean>(false);

  constructor(private campaignService: CampaignService) {
    super();
  }

  getUserProfile(): Observable<DonorProfile> {
    const url = `${this.baseApiUrl}/donor/profile`;
    // return this.httpAuthGet('./assets/mock/profile.json').pipe(
    return this.httpAuthGet(url).pipe(map((res) => res.data));
  }

  isUserOptOut = () => this._userOptoutState.asObservable();

  updateUserProfile(donarProfile: DonorProfile): Observable<boolean> {
    const url = `${this.baseApiUrl}/donor/profile`;
    const dataToSend = {
      ...donarProfile,
    };

    //return this.httpAuthPost('./assets/mock/profile.json').pipe(
    return this.httpAuthPost(url, dataToSend).pipe(
      map((res) => (res.data ? true : false))
    );
  }

  optOutFromCampaign(optOutRequest: { reason: string; comments: string }) {
    const campaignGuid = this.campaignService.getCurrentCampaignGuid();
    const url = `${this.baseApiUrl}/donor/campaign/${campaignGuid}/optout`;
    const dataToSend = {
      campaignGuid,
      ...optOutRequest,
      optout: true,
    };
    if (optOutRequest.reason === 'Other' || optOutRequest.reason === 'Autre') {
      dataToSend.reason = optOutRequest.comments;
    }
    //return this.httpAuthPost('./assets/mock/profile.json').pipe(
    return this.httpAuthPost(url, dataToSend).pipe(
      tap((_res) => this._userOptoutState.next(true))
    );
  }

  optInCampaign() {
    const campaignGuid = this.campaignService.getCurrentCampaignGuid();
    const url = `${this.baseApiUrl}/donor/campaign/${campaignGuid}/optout/status`;
    const dataToSend = {
      optout: false,
    };
    //return this.httpAuthPost('./assets/mock/profile.json').pipe(
    return this.httpAuthPost(url, dataToSend).pipe(
      map(res => res.data),
      tap((_res) => this._userOptoutState.next(false))
    );
  }

  getoptOutCampaignStatus() {
    const campaignGuid = this.campaignService.getCurrentCampaignGuid();
    const url = `${this.baseApiUrl}/donor/campaign/${campaignGuid}/optout/status`;
    //return this.httpAuthPost('./assets/mock/profile.json').pipe(
    return this.httpAuthGet(url).pipe(
      map(res => res.data),
      tap((res) => this._userOptoutState.next(res.optOut))
    );
  }

  getUWFeeSettings() {
    const url = `${this.baseApiUrl}/UWSetup/transaction-fees`;
    return this.httpAuthGet(url).pipe(
      map(res => res.data)
    );
  }
}
